import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ClientSummaryGroupModel } from '../../Models/Models/Business/ClientSummary/ClientSummaryGroupModel';
import { UserClientSummaryGroupSettingModel } from '../../Models/Domains/Users/UserClientSummaryGroupSettingModel';
import { IJsonDate } from '../../System/IJsonDate';
import { ServiceProposition } from '../../Constants/Enums/ServiceProposition';

declare var IS_RUNNING_IN_APP_POOL;

export class UserClientSummaryGroupSettingClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(setting: UserClientSummaryGroupSettingModel, hierarchyId: string, valuationDate: IJsonDate, servicePropositions: Array<ServiceProposition>): Promise<Array<ClientSummaryGroupModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/User/UserClientSummaryGroupSetting/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { setting: setting, hierarchyId: hierarchyId, valuationDate: valuationDate, servicePropositions: servicePropositions }

    return AjaxWrapper.post<Array<ClientSummaryGroupModel>, any>(url, data);
  }
}

